import initializeSendingReadReceipt from '../actions/initializeSendingReadReceipt';
import { infoReadReceiptRequested } from './createReadReceiptInfoBarMessage.locstring.json';
import doesItemResponseActionsHasGivenAction from './doesItemResponseActionsHasGivenAction';
import { isFolderOrSubFolderOfDistinguishedFolder } from 'owa-folders';
import loc from 'owa-localize';
import { infoLinkClickHere } from 'owa-locstrings/lib/strings/infolinkclickhere.locstring.json';
import isArchiveFolder from 'owa-mail-folder-store/lib/utils/isArchiveFolder';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import isSharedFolder from 'owa-mail-store/lib/utils/isSharedFolder';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    InfoBarCustomAction,
    InfoBarMessageColor,
    InfoBarMessageRank,
    InfoBarMessageSource,
    InfoBarMessageViewState,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

const SUPPRESS_READ_RECEIPT_ACTION_TYPE = 'SuppressReadReceipt:#Exchange';
const DO_NOT_AUTOMATICALLY_SEND = 'DoNotAutomaticallySend';
/**
 * This method creates infobar for read receipt
 * @param message - message item for which infobar will be created
 * @param key - infobar id
 * @param itemViewState - view state of the loading item
 */
export default function tryCreateReadReceiptInfoBarMessage(
    message: Message,
    key: string,
    itemViewState: ItemViewState
): InfoBarMessageViewState {
    if (shouldShowReadReceipt(message)) {
        const infoBarAction: InfoBarCustomAction = {
            action: () => {
                initializeSendingReadReceipt(message, key, itemViewState);
            },
            text: loc(infoLinkClickHere),
        };

        return <InfoBarMessageViewState>{
            key: key,
            source: InfoBarMessageSource.ReadingPane,
            rank: InfoBarMessageRank.Info,
            color: InfoBarMessageColor.Grey,
            messageParts: [loc(infoReadReceiptRequested), infoBarAction],
        };
    }
    return null;
}

/**
 * This method checks following all conditions
 * 1. Is feature flag enabled
 * 2. User configuration should be "DoNotAutomaticallySend"
 * 3. Item  should not in draft, junk, shared or archive folder
 * 4. Is read receipt requested from the sender's side
 * 5. Has the recipient sent the read receipt or not, if sent then
 * "SuppressReadReceipt" wont be present in Response Objects array in the getItem call and not to be shown if parent folder id is unknown
 *  @param message - message item
 */
function shouldShowReadReceipt(message: Message): boolean {
    const DRAFT_FOLDERID_NAME: DistinguishedFolderIdName = 'drafts';
    const JUNKEMAIL_FOLDERID_NAME: DistinguishedFolderIdName = 'junkemail';
    const isItemOfTypeJunkOrDraft =
        isFolderOrSubFolderOfDistinguishedFolder(message.ParentFolderId, DRAFT_FOLDERID_NAME) ||
        isFolderOrSubFolderOfDistinguishedFolder(message.ParentFolderId, JUNKEMAIL_FOLDERID_NAME);

    return (
        getUserConfiguration().UserOptions.ReadReceipt === DO_NOT_AUTOMATICALLY_SEND &&
        !isItemOfTypeJunkOrDraft &&
        message.ParentFolderId &&
        !isSharedFolder(message.ParentFolderId.Id) &&
        !isArchiveFolder(message.ParentFolderId.Id) &&
        message.IsReadReceiptRequested &&
        doesItemResponseActionsHasGivenAction(SUPPRESS_READ_RECEIPT_ACTION_TYPE, message)
    );
}
